import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsShopsCreation from "../creation-inner-pages/tms-bas-shops-creation";
import TmsBasCreatedShopsList from "../created-list-inner-pages/tms-sm-bas-shops-list";
const BuildingShop = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New Shop Creation
        </Button>
      </Row>
      <br />
      {!visible && <TmsBasCreatedShopsList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"Building Shop Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsShopsCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default BuildingShop;
